<tax-page-header titleText="cto.add.cto"></tax-page-header>

<div class="ui-kit-content-container">
  <!--TODO: fix $any-->
  <tax-param-block
    [title]="'menu.cto'"
    [placeholder]="'cto.add.cto.placeholder'"
    (createModal)="openCtoModal()"
    [details]="$any(newCto?.cto?.name)"
  ></tax-param-block>

  <hr class="greyline" />

  <tax-param-block
    [title]="'menu.kkms'"
    [placeholder]="'cto.add.kkm.placeholder'"
    (createModal)="openKkmsModal()"
    [details]="kkms"
  ></tax-param-block>

  <hr class="greyline" />

  <tax-param-block
    [title]="'cto.add.modules.title'"
    [placeholder]="'cto.add.modules.placeholder'"
    (createModal)="openModulesModal()"
    [details]="modules"
  ></tax-param-block>

  <div class="ui-kit-bottom-buttons-block">
    <button data-qa-button="go-back" class="back-button" (click)="goBack()" translate>
      group.back
    </button>

    <tax-checkbox
      class="checkbox"
      [id]="'contract'"
      [(ngModel)]="newCto.userAgreement"
      [labelTemplate]="contractTemplate"
      data-qa-checkbox="agreement"
    ></tax-checkbox>
    <ng-template #contractTemplate>
      <a
        [href]="
          '/api/cto/load-contract-pdf?ctoIinOrBin=' +
          newCto?.cto?.iinOrBin +
          '&ctoName=' +
          newCto?.cto?.name
        "
        target="_blank"
        data-qa-link="agreement"
      >
        {{ 'registration.offer.confirm.first.part' | translate }}
      </a>
      {{ 'registration.offer.confirm.second.part' | translate }}
    </ng-template>

    <button
      class="button_blue"
      (click)="saveCto()"
      [disabled]="!canSaveCto() || isSaveButtonPressed"
      translate
      data-qa-button="create-cto"
    >
      group.save
    </button>
  </div>
</div>
